<div class="user-settings">
  <ion-list lines="full">
    <ion-item>
      <ion-label>
        <div class="item-label">{{ 'USER_INFO.EMAIL' | translate }}</div>
        <div class="item-value">{{ email || ('GENERAL.NOT_AVAILABLE' | translate) }}</div>
      </ion-label>
    </ion-item>

    <ion-item button (click)="goToChangePassword()">
      <ion-label>{{ 'PREMIUM_MENU.CHANGE_PASSWORD' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>

    <ion-item *ngIf="isToggleEnabled('internationalization')" button (click)="openLanguageSwitcher()">
      <ion-label class="ion-text-wrap">
        <div>{{ 'ACCOUNT_SETTINGS.LANGUAGE' | translate }}</div>
      </ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>

    <ion-item class="default-landing-item">
      <ion-label>
        <div class="item-label">{{ 'USER_SETTINGS.DEFAULT_LANDING_PAGE' | translate }}</div>
      </ion-label>
      <ion-select
        slot="end"
        class="default-landing-select"
        [value]="defaultLandingPage"
        (ionChange)="onDefaultLandingPageChange($event)"
        interface="action-sheet"
        [cancelText]="'BUTTONS.CANCEL' | translate"
        [interfaceOptions]="defaultLandingSelectOptions"
        [attr.aria-label]="'USER_SETTINGS.DEFAULT_LANDING_PAGE' | translate"
      >
        <ion-select-option value="landing">{{ 'USER_SETTINGS.DEFAULT_LANDING_QUICK_ACTIONS' | translate }}</ion-select-option>
        <ion-select-option value="kiln-list">{{ 'USER_SETTINGS.DEFAULT_LANDING_KILN_LIST' | translate }}</ion-select-option>
        <ion-select-option value="information-radiator">{{ 'USER_SETTINGS.DEFAULT_LANDING_DASHBOARD' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item class="current-account-item" lines="full">
      <ion-label>
        <div class="item-label">{{ 'USER_SETTINGS.CURRENT_ACCOUNT' | translate }}</div>
        <div class="item-value">{{ currentAccountLabel() || ('GENERAL.NOT_AVAILABLE' | translate) }}</div>
        <div class="item-permission" *ngIf="currentAccountPermissionLabel()">
          <span>{{ 'USER_SETTINGS.YOUR_ROLE' | translate }}: {{ currentAccountPermissionLabel() }}</span>
          <ion-button
            fill="clear"
            size="small"
            class="role-info-button"
            (click)="presentRoleInfo($event)"
            [attr.aria-label]="'USER_SETTINGS.ROLE_INFO' | translate">
            <ion-icon slot="icon-only" name="information-circle-outline" color="medium"></ion-icon>
          </ion-button>
        </div>
      </ion-label>
      <ion-button
        slot="end"
        fill="clear"
        size="default"
        class="account-options-button"
        (click)="openAccountOptions()"
        [attr.aria-label]="'USER_SETTINGS.ACCOUNT_OPTIONS' | translate">
        <ion-icon name="swap-horizontal-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-item>

    <ion-item *ngIf="isPremiumAccount()" button (click)="goToAlertSettings()">
      <ion-label>{{ 'ACCOUNT_ADMIN.ALERT_SETTINGS' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>

    <ion-item *ngIf="isPremiumAccount()" button (click)="goToDeviceSettings()">
      <ion-label>{{ 'USER_SETTINGS.NOTIFICATION_SETUP' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>
  </ion-list>
</div>
